export * from './pipes/file-size.pipe'
export * from './pipes/obj2arr.pipe'
export * from './pipes/prop2arr.pipe'
export * from './pipes/sort.pipe'
export * from './pipes/pipes.module';